import { ChangeEventHandler, useRef} from "react"
import { ChordTypeHelper } from "../ChordTypeHelper/ChordTypeHelper"
import { HexPattern } from "../HexPattern/HexPattern"
import './HelperSelector.scss'
import { KeyCompass } from "../KeyCompass/KeyCompass"
import { ChordShapeHelper } from "../ChordShapeHelper/ChordShapeHelper"
import { CircleOfFifths, NoteCircle } from "../NoteCircle/NoteCircle"
import Draggable from "react-draggable"
import { useCourseStore, useOpenHelpers } from "../../Course/CourseStore"
import { CourseState } from "../../Course/CourseState"
import { ModeHelper } from "../ModeHelper/ModeHelper"

export function HelperWindowCloser(props:{index:number}){
    const remover:Function = useCourseStore((state:CourseState)=>{return state.removeOpenHelper})
    const onCloseClick = () => {remover(props.index)}
    return(<div className={'helper-window-closer'} onClick={onCloseClick}>x</div>)
}
export function HelperWindow(props:{title:string, index:number, children:React.ReactNode}){
        const nodeRef = useRef(null)
        return( <Draggable nodeRef={nodeRef}>
                    <div ref={nodeRef} className='helper-window-shell'>
                        <div className={'helper-title'}>{props.title}</div>
                        <HelperWindowCloser index={props.index}/>
                        {props.children}
                    </div>
                </Draggable>
        )
}
export class Helper{
    static ALPHABET:number = 0
    static CIRCLE_OF_FIFTHS:number = 1
    static HEX_PATTERN:number = 2
    static CHORD_TYPE:number = 3
    static CHORD_SHAPES:number = 4
    static COMPASS:number = 5
    static ALL:number[] = [0,1,2,3,4,5]
}

export function HelperSelector(){
    const openHelpers:number[] = useOpenHelpers()
    const removeOpenHelper:Function =   useCourseStore((state:CourseState)=>state.removeOpenHelper)
    const addOpenHelper:Function =      useCourseStore((state:CourseState)=>state.addOpenHelper)
    const setAllOpenHelpers:Function =  useCourseStore((state:CourseState)=>state.setOpenHelpers)
    const openAll:number = 1000
    const closeAll:number = 10000

    const titles:string[] = ['Musical Alphabet', 'Circle of Fifths', 'The Hex Pattern','ChordType Helper','Chord Shapes','Mode Names','The Key Compass']
    const getHelpers = () => {
        const helpers:React.ReactNode[] = [
                <HelperWindow index={0} title={titles[0]}>
                    <NoteCircle height={250} width={100} radius={85} caption={''}/>
                </HelperWindow>,
                <HelperWindow index={1} title={titles[1]}>
                    <CircleOfFifths height={220} width={200} radius={75}/>
                </HelperWindow>,
                <HelperWindow index={2} title={'The Hex Pattern'}>
                    <HexPattern height={220} width={300} radius={75}/>
                </HelperWindow>,
                <HelperWindow index={3} title={'ChordType Helper'}>
                    <ChordTypeHelper height={220} width={300} radius={75}/>
                </HelperWindow>,
                <HelperWindow index={4} title={'Chord Shapes'}>
                    <ChordShapeHelper height={220} width={300} radius={75}/>
                </HelperWindow>,
                <HelperWindow index={5} title={'Mode Names'}>
                    <ModeHelper height={210} width={300} radius={75}/>
                </HelperWindow>,
                <HelperWindow index={5} title={'The Key Compass'}>
                    <KeyCompass height={210} width={300} radius={34}/>
                </HelperWindow>
            ]
        return helpers
    }
    const OpenHelperNodes = () => {
        const helpers:React.ReactNode[] = getHelpers()
        const openHelperNodes:React.ReactNode[] = []
        openHelpers.forEach((helperIndex:number)=>{
            openHelperNodes.push(helpers[helperIndex])
        })
        return <>{openHelperNodes}</>
    }
    const onSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const index:number = Number(e.target.value)
        if(index < 0) return
        if(index === openAll){
            setAllOpenHelpers(Helper.ALL)
            return
        }
        if(index === closeAll){
            setAllOpenHelpers([])
            return
        }
        if(openHelpers.includes(index)){
            removeOpenHelper(index)
            return
        }
        addOpenHelper(index)
    }

    const HelperSelect = (props:{onSelect:ChangeEventHandler<HTMLSelectElement>}) => {
        const getHelperOptions = () => {
            return(
                    titles.map((title:string, index:number)=>{
                        return <option key={index} value={index}>{title}</option>
                    })
            )
        }
        return(
            <>Helpers: <select onChange={props.onSelect} value={-1}>
                    <option key={-1} value={-1}>--Choose a Helper Pattern--</option>
                    {getHelperOptions()}
                    <option key={closeAll} value={closeAll}>  Close All  </option>
                    <option key={openAll} value={openAll}> Open All </option>
                </select>
            </>
        )
    }
    return(
        <div className={'helper-selector'}>
            <div className="select-constainer collapsible">
                <HelperSelect onSelect={onSelectChange}/>
            </div>
            <div className="helpers-container">
                <OpenHelperNodes/>
            </div>
            
        </div>
    )
}